import { _ as n } from "./atoms-v21295.js";
var l = n;
function a(t) {
  var e = t == null ? 0 : t.length;
  return e ? l(t, 1) : [];
}
var o = a;
export {
  o as f
};
